import React from "react";
import { Alert, Button, Spin } from "antd";
import { useAircrafts, useAirports, useFlightLegs } from "../../../../hooks/useReferenceData";

const ReferenceDataProvider = ({ children }) => {
    const airportsQuery = useAirports();
    const aircraftsQuery = useAircrafts();
    const flightLegsQuery = useFlightLegs();

    const error = airportsQuery.queryError || aircraftsQuery.error || flightLegsQuery.error;
    const isLoading = airportsQuery.isLoading || aircraftsQuery.isLoading || flightLegsQuery.isLoading;

    const retry = () => {
        airportsQuery.refetch();
        aircraftsQuery.refetch();
        flightLegsQuery.refetch();
    };

    if (error) {
        return <Alert type="error" showIcon message="加载引用数据失败" description={error.message || String(error)} action={<Button onClick={retry}>重试</Button>} />;
    }

    return <Spin spinning={isLoading} tip="正在加载引用数据...">{children}</Spin>;
};

export default ReferenceDataProvider;
